import {EnvBankDomain} from "../../domain/env/EnvBankDomain"

export const EnvBankDescriptor: Record<keyof EnvBankDomain, (o: EnvBankDomain) => string> = {
    id(o: EnvBankDomain): string {
        return o.id.toString()
    },
    creatorId(o: EnvBankDomain): string {
        return o.creatorId.toString()
    },
    name(o: EnvBankDomain): string {
        return o.name
    },
    displayOrder(o: EnvBankDomain): string {
        return o.displayOrder.toString()
    },
    assetSolarWithdrawalCount(o: EnvBankDomain): string {
        return o.assetSolarWithdrawalCount.toString()
    },
    createdAt(o: EnvBankDomain): string {
        return o.createdAt.toISOString().substring(0, 19).replace('T', ' ')
    },
    lastModifiedAt(o: EnvBankDomain): string {
        return o.lastModifiedAt?.toISOString().substring(0, 19).replace('T', ' ') ?? '-'
    },
    concealedAt(o: EnvBankDomain): string {
        return o.concealedAt?.toISOString().substring(0, 19).replace('T', ' ') ?? '-'
    }
}
